module.exports = __webpack_public_path__ + "img/CC88.42d13045.png";